import React, { useState } from 'react';
import styles from '../../styles/common/common.module.css';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import classnames from 'classnames';
import { FiMenu } from "react-icons/fi";
import Sidebar from './Sidebar';
import { SecHeaderProps } from '../../interfaces/common/funtions';

// const SecHeader: React.FC = () => {
const SecHeader: React.FC<SecHeaderProps> = ({ handleLogout, isAuthenticated, setIsAuthenticated }) => {
    // show and hide sidebar functionality
    const [showSidebar, setShowSidebar] = useState(false);
    // show header in responsive screens
    const [expanded, setExpanded] = useState(false);
    const location = useLocation();

    const handleToggle = () => setExpanded(!expanded);
    const handleClose = () => setExpanded(false);

    return (
        <>
            <Navbar
                bg="dark"
                variant="dark"
                expand="lg"
                className={styles.header}
                expanded={expanded}
            >
                <Container fluid>
                    <Navbar.Toggle
                        aria-controls="basic-navbar-nav"
                        onClick={handleToggle}
                    />
                    <FiMenu onClick={() => setShowSidebar(true)} className={styles.fiIcon} /> {/* Use the icon here */}
                    {/* <Sidebar show={showSidebar} onHide={() => setShowSidebar(false)} /> */}
                    <Sidebar
                        show={showSidebar}
                        onHide={() => setShowSidebar(false)}
                        handleLogout={handleLogout}
                        isAuthenticated={isAuthenticated}
                        setIsAuthenticated={setIsAuthenticated}
                    />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            {[
                                { label: "🎆 Diwali Deals", to: "/diwali-deals" },
                                { label: "Best Sellers", to: "/best-sellers" },
                                { label: "Trending", to: "/trending" },
                                { label: "Best Rated", to: "/best-rated" },
                                { label: "Apparel", to: "/category/apparel-accessories" },
                                { label: "Shoes", to: "/category/shoes" },
                                { label: "Beauty", to: "/category/beauty" },
                                { label: "Limited Sell", to: "/limited-offers" },
                                { label: "Latest Sell", to: "/latest-sellings" },
                            ].map((item) => (
                                <Nav.Link
                                    as={NavLink}
                                    to={item.to}
                                    className={classnames(styles.navLink, {
                                        [styles.active]: location.pathname === item.to,
                                    })}
                                    onClick={handleClose}
                                    key={item.label}
                                >
                                    {item.label}
                                </Nav.Link>
                            ))}
                        </Nav>
                        <Nav className="ms-auto">

                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
};

export default SecHeader;
